// extracted by mini-css-extract-plugin
module.exports = {"title_tour_content_left":"LeftContentTour_title_tour_content_left__hu5f7","text_tour_content_left":"LeftContentTour_text_tour_content_left__3A1sU"};